import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { PropTypes as mobxPropTypes } from 'mobx-react';
import { Checkbox, mergeStyleSets } from '@fluentui/react';

import { weekdays } from 'shared/services/scheduler';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignContent: 'space-between',

    selectors: {
      '& > *': {
        margin: '0px 16px 16px 0px',
      },
    },
  },
})

const WeekdaySelector = ({ value, onChange }) => {
  const days = useMemo(() => weekdays.reduce((acc, val) => (acc[val] = value.includes(val), acc), {}), [value]);

  function handleSelectDay(day, checked) {
    const items = { ...days, [day]: checked };
    onChange(weekdays.filter(v => !!items[v]));
  }

  return (
    <div className={classNames.root}>
      {
        weekdays.map(item => (
          <Checkbox key={item} label={item} checked={days[item]}
            onChange={(event, checked) => handleSelectDay(item, checked)}
          />
        ))
      }
    </div>
  )
}

WeekdaySelector.propTypes = {
  value: mobxPropTypes.arrayOrObservableArrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
}

export default WeekdaySelector;